import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { Order } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema, orderSchema } from '../lib/schemas';

export const orderService = {
  getOrders: async (): Promise<Order[]> => {
    const result = await apiClient.get(apiUrl.orders(), {
      validate: envelopeSchema('orders', z.array(orderSchema)),
      deduplicate: true,
      context: 'getOrders',
    });
    return result.orders;
  },

  getOrdersByProject: async (projectId: string): Promise<Order[]> => {
    const result = await apiClient.get(apiUrl.projectOrders(projectId), {
      validate: envelopeSchema('orders', z.array(orderSchema)),
      deduplicate: true,
      context: 'getOrdersByProject',
    });
    return result.orders;
  },

  async createOrder(order: Partial<Order>): Promise<Order> {
    const result = await apiClient.post(apiUrl.orders(), order, {
      validate: envelopeSchema('order', orderSchema),
      context: 'createOrder',
    });
    return result.order;
  },

  async updateOrder(id: string, order: Partial<Order>): Promise<Order> {
    const result = await apiClient.put(apiUrl.orders(id), order, {
      validate: envelopeSchema('order', orderSchema),
      context: 'updateOrder',
    });
    return result.order;
  },

  async deleteOrder(id: string): Promise<void> {
    await apiClient.delete(apiUrl.orders(id), {
      context: 'deleteOrder',
    });
  },
};
